import * as React from 'react';

const NeuralNetworkIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height={22} viewBox="0 0 22 22" width={22} xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M19.7083 11.0002C19.7083 12.2658 18.6823 13.2918 17.4167 13.2918C16.151 13.2918 15.125 12.2658 15.125 11.0002C15.125 9.73452 16.151 8.7085 17.4167 8.7085C18.6823 8.7085 19.7083 9.73452 19.7083 11.0002Z"
            stroke="white"
            strokeWidth={1.5}
        />
        <path
            d="M12.375 3.6665C12.375 4.4259 11.7594 5.0415 11 5.0415C10.2406 5.0415 9.625 4.4259 9.625 3.6665C9.625 2.90711 10.2406 2.2915 11 2.2915C11.7594 2.2915 12.375 2.90711 12.375 3.6665Z"
            stroke="white"
            strokeWidth={1.5}
        />
        <path
            d="M11.4583 10.5415C11.4583 11.3009 10.8426 11.9165 10.0833 11.9165C9.32389 11.9165 8.70825 11.3009 8.70825 10.5415C8.70825 9.78214 9.32389 9.1665 10.0833 9.1665C10.8426 9.1665 11.4583 9.78214 11.4583 10.5415Z"
            stroke="white"
            strokeWidth={1.5}
        />
        <path
            d="M5.95842 6.87484C5.95842 7.88736 5.1376 8.70817 4.12508 8.70817C3.11256 8.70817 2.29175 7.88736 2.29175 6.87484C2.29175 5.86231 3.11256 5.0415 4.12508 5.0415C5.1376 5.0415 5.95842 5.86231 5.95842 6.87484Z"
            stroke="white"
            strokeWidth={1.5}
        />
        <path
            d="M9.62492 17.8748C9.62492 18.8874 8.80411 19.7082 7.79159 19.7082C6.77906 19.7082 5.95825 18.8874 5.95825 17.8748C5.95825 16.8623 6.77906 16.0415 7.79159 16.0415C8.80411 16.0415 9.62492 16.8623 9.62492 17.8748Z"
            stroke="white"
            strokeWidth={1.5}
        />
        <path
            d="M12.3749 4.58333L16.0416 9.16667M13.2916 14.2083L9.62492 16.9583M7.33325 16.0417L4.58325 8.70833M5.78682 6.09978L9.62492 4.125M11.4583 10.5417L15.1295 10.8573"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
        />
        <path
            d="M10.9999 5.0415L10.0833 9.1665"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
        />
    </svg>
);
export default NeuralNetworkIcon;
